import  { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import config from "../config.js";

const EmailMarketingResult = () => {
    const [subscribers, setSubscribers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { API_BASE_URL } = config;
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/v1/MarketingworkbookToJson`);
                // Check if response.data.Google exists and is an array
                if (response.data.data && response.data.data.Google && Array.isArray(response.data.data.Google)) {
                    setSubscribers(response.data.data.Google);
                } else {
                    console.error("Invalid data structure:", response.data);
                    setError(new Error("Invalid data structure"));
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setError(error);
                setLoading(false);
            }
        };
        
        fetchData();
    }, [API_BASE_URL]);
    
    // Only process chart data if subscribers array is populated
    const prepareChartData = () => {
        if (!subscribers || subscribers.length === 0) {
            return {
                labels: [],
                datasets: [
                    {
                        label: 'Direct',
                        data: [],
                        borderColor: 'rgba(255, 99, 132, 1)',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                    },
                ],
            };
        }
        
        const dates = subscribers.map(entry => entry.DATE);
        const directData = subscribers.map(entry => entry.DIRECT);
        
        return {
            labels: dates,
            datasets: [
                {
                    label: 'Direct',
                    data: directData,
                    borderColor: 'rgba(255, 99, 132, 1)',
                    backgroundColor: 'rgba(255, 99, 132, 0.2)',
                },
            ],
        };
    };
    
    const chartData = prepareChartData();
    
    const options = {
        plugins: {
            legend: {
                display: true,
            },
        },
        scales: {
            x: {
                display: true,
                title: {
                    display: true,
                    text: 'Date',
                },
            },
            y: {
                display: true,
                title: {
                    display: true,
                    text: 'Subscribers',
                },
            },
        },
    };
    
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress />
            </Box>
        );
    }
    
    if (error) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <Typography variant="h6" color="error">
                    Error loading data. Please try again later.
                </Typography>
            </Box>
        );
    }
    
    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" color="textPrimary">Email Marketing</Typography>
                <Button sx={{ backgroundColor: "#FD6262" }} variant="contained">Result</Button>
            </Box>
            <Box display="flex" justifyContent="center" mb={2}>
                <Typography variant="body1" color="textSecondary">Subscribers</Typography>
            </Box>
            <Box display="flex" justifyContent="center" gap={2} mb={2}>
                <Typography variant="body2" color="textSecondary">Vs Yesterday</Typography>
                <Typography variant="body2" color="textSecondary">Vs Last Week</Typography>
            </Box>
            <Box>
                {subscribers.length > 0 ? (
                    <Line data={chartData} options={options} />
                ) : (
                    <Typography variant="body1" textAlign="center">No subscriber data available</Typography>
                )}
            </Box>
        </Box>
    );
};

export default EmailMarketingResult;


